<template>
  <div style="padding-top: 100px;">
    <SignupAgree v-if="step === 1" @toForm="toForm"/>
    <SignupForm v-if="step === 2" @nextPage="nextPage" :marketing="marketing"/>
    <SignupConnect v-if="step === 3" @nextPage="nextPage"/>
  </div>
</template>

<script>
import SignupAgree from './signupSteps/SignupAgree.vue';
import SignupConnect from './signupSteps/SignupConnect.vue';
import SignupForm from './signupSteps/SignupForm.vue';

export default {
  components: {
    SignupAgree,
    SignupForm,
    SignupConnect
  },

  data () { 
    return {
      step: 1,
      marketing: {}
    }
  },

  methods: {
    nextPage() {
      this.step++
    },

    toForm(payload) {
      if (payload.marketingAgree) {
        this.marketing = payload.marketing
      }
      this.step++

    }
  }
}
</script>
<style lang="">

</style>